module.exports = __webpack_public_path__ + "static/logos-08243481636d4e8c2edb2b32f5cc8fda.pdf";